import NoData from "components/NoData/NoData"
import React from "react"

export const TableRowsHoc = ({ length = 0, children = [] }) =>
  length ? children : <NoData span={"8"} />
